import { combineReducers } from 'redux'
import DefaultReducers from 'reducers'

export default combineReducers({ ...DefaultReducers })
